








import BoxEdit from "@/components/products/malennachzahlen/design/BoxEdit.vue"
import BoxEditBig from "@/components/products/malennachzahlen/design/BoxEditBig.vue"
import PaintingImage from "@/components/products/malennachzahlen/design/PaintingImage.vue"
import { PaintingByNumbersModule } from '@/store/modules/paintingByNumbers'
import { AppModule } from '@/store/modules/app'
import CartButton from "@/components/products/malennachzahlen/util/CartButton.vue"

export default {
    name: "painting-by-numbers-design",

    components: {
        BoxEdit,
        BoxEditBig,
        PaintingImage,
        CartButton
    },
    computed: {
        showBoxEdit: function () {
            return PaintingByNumbersModule.showBox || PaintingByNumbersModule.showTitle || (AppModule.showMenu && PaintingByNumbersModule.stepThreeCompleted)
        },
        showPuzzle: function() {
            return PaintingByNumbersModule.showPainting || PaintingByNumbersModule.showImagePreview || (AppModule.showMenu && !PaintingByNumbersModule.stepThreeCompleted)
        }
    }
}
